import {bindActionCreators, compose} from 'redux';
import {reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import {actions} from './../../../redux/actions';

const mapStateToProps = (state: any) => {
  return {
    users: state.users,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    actions: {
      users: bindActionCreators(actions.users, dispatch),
    },
  };
};

const enhance: any = compose(
  connect(mapStateToProps, mapDispatchToProps),
  reduxForm({
    form: 'usersMain',
  })
);

export {enhance};
